import { LocationAddress, Maybe } from "../generated/nest-graphql";

const filled = (value?: Maybe<string>): value is string => !!value && value.trim().length > 0;

/**
 * "8235 Macgregor Dr, Arlington, TX 76002-3048", or undefined unless street, city, state and zip
 * are all present. Used for navigation so a partial serviceLocation can't send the technician to
 * the wrong city (NUB-466).
 */
export const formatLocationAddress = (address?: Maybe<LocationAddress>): string | undefined => {
  if (!address || ![address.addressLine, address.city, address.state, address.zipCode].every(filled)) {
    return undefined;
  }
  const street = [address.addressLine, address.addressLine2]
    .filter(filled)
    .map((part) => part.trim())
    .join(", ");
  return `${street}, ${address.city!.trim()}, ${address.state!.trim()} ${address.zipCode!.trim()}`;
};
